import CompanyBillingTab from 'src/components/pages/Company/CompanyPage/CompanyBillingTab/CompanyBillingTab';

export default CompanyBillingTab;
